import { Icon } from '../../../components/icons/Icon'
import type { AiProvenanceView } from '../../../types/aiCartridgeDraft'

export interface AiDraftCitationListProps {
  citations: AiProvenanceView[]
}

function sourceTypeLabel(sourceType: string): string {
  return sourceType
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

/**
 * Renders one row per `AiProvenance` citation grounding a cartridge-draft proposal (FR-M7.5 AC —
 * "citations out"). `role` names which rule/gate the citation grounds (the composer's own
 * convention, `CartridgeDraftComposer`); `sourceId` is a polymorphic reference with no FK and no
 * browsable canon repository in this slice yet, so it renders as a short, honest id, not a fabricated
 * deep-link (disclosed gap — see `AiDraftProposalCard`'s doc comment).
 */
export function AiDraftCitationList({ citations }: AiDraftCitationListProps) {
  if (citations.length === 0) {
    return (
      <p style={{ margin: 0, fontSize: 'var(--iw-size-xs)', color: 'var(--iw-text-muted)' }}>
        No grounding citations were supplied with this draft request.
      </p>
    )
  }
  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 'var(--iw-space-1)' }}>
      {citations.map((c) => (
        <li
          key={c.id}
          style={{ display: 'flex', alignItems: 'center', gap: 'var(--iw-space-2)', fontSize: 'var(--iw-size-xs)' }}
        >
          <Icon name="bookmark" size={12} />
          <span className="iw-pill iw-pill--neutral">{sourceTypeLabel(c.sourceType)}</span>
          <span>{c.role}</span>
          <code style={{ color: 'var(--iw-text-muted)' }}>{c.sourceId}</code>
        </li>
      ))}
    </ul>
  )
}
